import * as tslib_1 from "tslib";
import expandItemPartOnIsReadChanged from './expandItemPartOnIsReadChanged';
import readingPaneStore from '../store/Store';
import store from 'owa-mail-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';
export default action('markConversationsReadInReadingPane')(select({
    conversations: function () { return store.conversations; },
    conversationNodes: function () { return store.conversationNodes; },
    items: function () { return store.items; },
    loadedConversationId: function () {
        return readingPaneStore.conversationReadingPaneViewState &&
            readingPaneStore.conversationReadingPaneViewState.conversationId;
    },
})(function markConversationsReadInReadingPaneStore(conversationIds, shouldMarkAsRead, folderId, state) {
    var nodeIdCollectionHasItemChangedToUnread = [];
    conversationIds.forEach(function (conversationId) {
        var e_1, _a, e_2, _b;
        if (state.conversations.has(conversationId)) {
            var conversationItemParts = state.conversations.get(conversationId);
            try {
                for (var _c = tslib_1.__values(conversationItemParts.conversationNodeIds), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var conversationNodeId = _d.value;
                    var conversationNode = state.conversationNodes.get(conversationNodeId);
                    // Skip if the conversation node is not existed.
                    if (!conversationNode) {
                        continue;
                    }
                    var hasItemChangedToUnread = false;
                    try {
                        for (var _e = tslib_1.__values(conversationNode.itemIds), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var itemId = _f.value;
                            var message = state.items.get(itemId);
                            if (message.ConversationId.Id == conversationId &&
                                (folderId == null || message.ParentFolderId.Id == folderId)) {
                                if (state.loadedConversationId &&
                                    state.loadedConversationId.Id == conversationId) {
                                    // For reading pane current loaded conversation, check if node has item changed from read to unread.
                                    hasItemChangedToUnread =
                                        hasItemChangedToUnread || (message.IsRead && !shouldMarkAsRead);
                                }
                                message.IsRead = shouldMarkAsRead;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    if (hasItemChangedToUnread) {
                        nodeIdCollectionHasItemChangedToUnread.push(conversationNodeId);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    });
    if (nodeIdCollectionHasItemChangedToUnread.length > 0) {
        expandItemPartOnIsReadChanged(conversationIds[0], nodeIdCollectionHasItemChangedToUnread);
    }
}));
//# sourceMappingURL=markConversationsReadInReadingPaneStore.js.map